import { ApiResponse, UpdateOrder } from '../types';
import { API_URL } from '../../common/utils';

/**
 * Obtiene los detalles de una orden desde la API
 * @param orderId - ID de la orden en Shopify
 * @returns Promesa con los detalles de la orden
 */
const getOrderDetails = async (orderId: string): Promise<ApiResponse> => {
  try {
    const response = await fetch(`${API_URL}/shopify/orders/${orderId}`);
    
    if (!response.ok) {
      throw new Error(`Error al obtener la orden: ${response.statusText}`);
    }
    
    const data: ApiResponse = await response.json();
    return data;
  } catch (error) {
    console.error('Error al obtener los detalles de la orden:', error);
    throw error;
  }
}; 

/**
 * Actualiza la dirección de envío de una orden por su ID de Shopify
 * @param shopifyId - ID de la orden en Shopify
 * @param shippingAddress - Datos de dirección de envío actualizados
 * @returns Promesa con la respuesta de la actualización
 */
const updateOrderByShopifyId = async (id: string, shipping_address: UpdateOrder): Promise<ApiResponse> => {
  try {
    const response = await fetch(`${API_URL}/shopify/orders`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: parseInt(id),
        ...shipping_address,
      }),
    });
    
    if (!response.ok) {
      throw new Error(`Error al actualizar la orden: ${response.statusText}`);
    }
    
    const data: ApiResponse = await response.json();
    return data;
  } catch (error) {
    if (error instanceof Error) {
      console.error('Error al actualizar la orden:', error.message);
    } else {
      console.error('Error desconocido al actualizar la orden');
    }
    throw error;
  }
}; 

export {
  getOrderDetails,
  updateOrderByShopifyId,
};
